import React from "react";

const ITEMS = [
  "Where renting feels like home",
  "No brokerage",
  "Fully furnished",
  "Community first",
  "Zero deposit drama",
  "Pune's multiliving OG",
];

export default function Marquee() {
  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee-track">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i} className="inline-flex items-center gap-3">
            <span className="text-2xl">✦</span> {t}
          </span>
        ))}
      </div>
    </div>
  );
}
